import { Routes } from '@angular/router';
import { MyAccountComponent } from './components/my-account/my-account.component';

export const MY_ACCOUNT_ROUTES: Routes = [

  { path: 'my-account', component: MyAccountComponent },

];
